module.exports = require("@swa-ui/personal-info/src/form/PassengerAccommodationsFormFields/AnimalAssistanceFormField/AnimalAssistanceFormField.module.scss");